import { FormGroup } from "@blueprintjs/core";
import { ItemSelect } from "@package/ui-apollo-components";
import {
  ActionPayloadType,
  GetLocationListNameIdDocument,
  GetProfileListNameIdDocument,
  type GetLocationListNameIdQuery,
  type GetLocationListNameIdQueryVariables,
  type GetProfileListNameIdQuery,
  type GetProfileListNameIdQueryVariables,
} from "@package/ui-gql/index-data-access";
import { type SchedulerEditActionProps } from "./scheduler-edit-action-props";

export function SchedulerEditActionChangeLocationProfile({
  action,
  disabled,
  onChange,
}: SchedulerEditActionProps) {
  if (
    action?.type == ActionPayloadType.ActionLocationProfileChanged &&
    action?.__typename === "ActionPayloadLocationProfileChanged"
  ) {
    return (
      <>
        <FormGroup disabled={disabled} label="Location">
          <ItemSelect<
            GetLocationListNameIdQuery,
            GetLocationListNameIdQueryVariables
          >
            activeItemId={action.location}
            disabled={disabled}
            document={GetLocationListNameIdDocument}
            nullable={false}
            onItemSelected={(id) => {
              if (id) {
                onChange({
                  ...action,
                  location: id,
                });
              }
            }}
          />
        </FormGroup>
        <FormGroup disabled={disabled} label="Profile">
          <ItemSelect<
            GetProfileListNameIdQuery,
            GetProfileListNameIdQueryVariables
          >
            activeItemId={action.profile}
            disabled={disabled}
            document={GetProfileListNameIdDocument}
            nullable={false}
            onItemSelected={(id) => {
              if (id) {
                onChange({
                  ...action,
                  profile: id,
                });
              }
            }}
          />
        </FormGroup>
      </>
    );
  }

  return null;
}
